import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { GetDressCodeAction } from '../../actions/dress-code/get-dress-code-action';
import { GetDressCodeSuccessAction } from '../../actions/dress-code/get-dress-code-success-action';
import { GetDressCodeErrorAction } from '../../actions/dress-code/get-dress-code-error-action';

@Injectable()
export class GetDressCodeEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public GetDressCodesActions = createEffect(() => this.actions
    .pipe(
      ofType(GetDressCodeAction.type),
      mergeMap(action => {
        const getDressCodeAction = <GetDressCodeAction>action;
        return this.api.getDressCode(getDressCodeAction.bijbEvent).then(dressCode => {
          return new GetDressCodeSuccessAction(dressCode);
        }, error => {
          return new GetDressCodeErrorAction({ ...error, fatal: true });
        });
      })
    ));
}
